module.exports = __webpack_public_path__ + "img/test.f9ea9361.png";